export async function init(container: HTMLElement) {
  
  if (!container) return;

  const noDate = 
    navigator.userAgent.match('Firefox') || 
    (navigator.userAgent.match('Safari') && !navigator.userAgent.match('Chrome'));

  const list = container.querySelector('.feed-list') as HTMLElement;
  const url  = list.dataset.url;
  const de   = list.dataset.language == 'de';
  
  try {
    
    const res       = await fetch(url);
    const xml       = await res.text();
    const cleanXml  = xml.replace(/<\?xml.*\?>/gi, '');
    const domParser = new DOMParser();
    const doc       = domParser.parseFromString(cleanXml, 'application/xml');
    
    const items = Array.from(doc.querySelectorAll('item'))
    .slice(0, 5)
    .map(item => {
      const titleElm = item.querySelector('title')       as HTMLElement;
      const descElm  = item.querySelector('description') as HTMLElement;
      const linkElm  = item.querySelector('link')        as HTMLElement;
      const dateElm  = item.querySelector('pubDate')     as HTMLElement;
      
      const title      = !!titleElm ? titleElm.textContent : '';
      const desc       = !!descElm  ? descElm.textContent  : '';
      const link       = !!linkElm  ? linkElm.textContent  : '';

      let deskDesc = desc;
      if (!noDate) {
        const dateClean  = dateElm.textContent.replace(/ (CEST)|(CET)/, '');
        const dateObj    = !!dateElm  ? new Date(dateClean) : '';
        const date       = !!dateObj ? (
          de ? new Intl.DateTimeFormat('de-CH').format(dateObj) : 
          /*else*/ new Intl.DateTimeFormat('en').format(dateObj)
          ) : '';

        deskDesc         = [date, desc].join(' – ');
      }
 
      const button     = `<a class="button" target="_blank" href="${link}">${de ? 'Mehr' : 'More'}</a>`;
      const mobileLink = `<a class="mobile-link" target="_blank" href="${link}">${!!title ? title : desc}</a>`;
      const deskTitle  = `<h3>${title}</h3>`;
      const deskText   = `<p>${deskDesc}</p>`;
      
      return '<li>' + button + deskTitle + deskText + mobileLink + '</li>';
    });
    
      list.innerHTML = items.join('');
    }
    catch(e) {
      console.log(`Error in fetching ${url}`);
      console.log(e);
    }    
}
